import React from 'react';
import throttle from 'lodash/throttle';
import { withState, withHandlers, compose, lifecycle } from 'recompose';
import styled, { StylesProps } from '../../../lib/styles';
import Spacer from '../../../components/presentational/Spacer';
import { Article } from '../../../models/article';

import stickyRecirculationStyles from './StickyRecirculation_styles';
import Ad, { Ad as AdData } from '../../../components/presentational/Ad';

export interface StickyRecirculationProps {
  recirculationAd1?: AdData;
  articles: Article[];
  collapsed?: boolean;
  isScrollingUp?: boolean;
  onClick?: (slug: string) => any;
}

const StickyRecirculation = ({
  recirculationAd1,
  articles,
  onClick,
  styles,
}: StickyRecirculationProps &
  StylesProps<typeof stickyRecirculationStyles>) => (
  <div className={styles.container}>
    <div className={styles.recirculation}>
      {recirculationAd1 && (
        <Ad
          className={styles.ad}
          ad={recirculationAd1}
          gutter={false}
          lazy
          // backgroundColor="transparent"
          initialSize={['100%', 50]}
        />
      )}
      {articles.map(({ link, title, slug, thumbnail_image }, i) => (
        <Spacer key={i} row space={'xs'} className={styles.article}>
          <a
            className={styles.imageLink}
            href={link}
            title={title}
            onClick={() => onClick && onClick(slug)}
          >
            <img
              className={styles.image}
              width={50}
              height={50}
              alt={'Read more'}
              src={thumbnail_image}
            />
          </a>

          <a
            className={styles.title}
            href={link}
            title={title}
            onClick={() => onClick && onClick(slug)}
          >
            {title}
          </a>
        </Spacer>
      ))}
    </div>
  </div>
);

const STICKY_RECIRC_DELAY_MS = 1500;

export default compose(
  withState('isScrollingUp', 'setIsScrollingUp', false),
  withHandlers(() => {
    let lastScrollTop = 0;

    return {
      handleScroll: ({ isScrollingUp: wasScrollingUp, setIsScrollingUp }) =>
        throttle(() => {
          const isScrollingUp =
            window.scrollY > 150 && lastScrollTop > window.scrollY;

          if (isScrollingUp !== wasScrollingUp) setIsScrollingUp(isScrollingUp);

          lastScrollTop = window.scrollY;
        }, STICKY_RECIRC_DELAY_MS),
    };
  }),
  lifecycle({
    componentDidMount(this: any) {
      let supportsPassive = false;

      try {
        const opts = Object.defineProperty({}, 'passive', {
          get: function () {
            supportsPassive = true;
          },
        });

        window.addEventListener('testPassive', null as any, opts);
        window.removeEventListener('testPassive', null as any, opts);
      } catch (e) {}

      supportsPassive = false;

      window.addEventListener(
        'scroll',
        this.props.handleScroll,
        supportsPassive ? { passive: true } : false
      );
    },

    componentWillUnmount(this: any) {
      window.removeEventListener('scroll', this.props.handleScroll);
    },
  }),
  styled(stickyRecirculationStyles)
)(StickyRecirculation);
